const e=e=>Array.isArray(e)||typeof e==`string`;export{e as isScope};
//# sourceMappingURL=is-scope.mjs.map